export const descriptionTextStyles = {
  fontWeight: 'semiBold',
  fontSize: 5,
  lineHeight: ['1.3', '1.5'],
};

export const priceUpsellCountStyles = {
  fontSize: 5,
  lineHeight: 1,
};

export const itemQuantityContainerStyles = {
  justifyContent: 'flex-end',
  ml: 'auto',
  flex: 2,
};

export const checkboxContainerStyles = {
  justifyContent: 'center',
};

export const checkboxStyles = {
  color: 'backgroundDisabled',
};
